import { zodResolver } from "@hookform/resolvers/zod";
import { useForm as useHookForm } from "react-hook-form";
import type { z } from "zod";

export const useForm = <T extends z.ZodTypeAny>(schema: T, defaultValues: z.infer<T>) =>
	useHookForm({
		resolver: zodResolver(schema),
		defaultValues,
	});
